import dayjs from 'dayjs'
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)

export function isDateTimeInRange(dateTime, dateStart, dateEnd, tzSeconds) {
    if (!dateStart || !dateEnd) return false
    let dateTimeObject

    if (dateTime) {
        dateTimeObject = dayjs(dateTime).utc().add(tzSeconds, 'second')
    }
    else {
        dateTimeObject = dayjs(new Date()).utc().add(tzSeconds, 'second')
    }

    dateTimeObject = dayjs(dateTimeObject.format('YYYY-MM-DD HH:mm'))

    return dateTimeObject.isBetween(dateStart, dateEnd, 'second', '[]')
}